import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { Box, Container, Typography, CircularProgress, Button } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLang } from '../../contexts/langContext';

function DocumentReader() {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { docType } = useParams();
  const navigate = useNavigate();
  const { lang } = useLang();

  useEffect(() => {
    const fetchDocument = async () => {
      try {
        const response = await fetch(`/docs/${docType}.md`);
        if (!response.ok) {
          throw new Error('Document not found');
        }
        const text = await response.text();
        setContent(text);
      } catch (err) {
        setError('Failed to load document');
      } finally {
        setLoading(false);
      }
    };

    fetchDocument();
  }, [docType]);

  const handleBack = () => {
    navigate('/');
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 2 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          variant="text"
          sx={{ mb: 2 }}
        >
          {lang === 'zh-CN' ? '返回首页' : lang === 'zh-HK' ? '返回首頁' : 'Back to Home'}
        </Button>
      </Box>
      <Box sx={{ 
        '& img': { maxWidth: '100%', height: 'auto' },
        '& h1, & h2, & h3, & h4, & h5, & h6': { mt: 3, mb: 2 },
        '& p': { mb: 2 },
        '& code': { bgcolor: 'grey.100', p: 0.5, borderRadius: 1 }
      }}>
        <ReactMarkdown>{content}</ReactMarkdown>
      </Box>
    </Container>
  );
}

export default DocumentReader; 